import { Skeleton as MuiSkeleton } from "@mui/material";
import type {
  SkeletonProps as MuiSkeletonProps,
  SxProps,
  Theme,
} from "@mui/material";

export type SkeletonProps = Pick<
  MuiSkeletonProps,
  "variant" | "width" | "height" | "animation" | "children"
> & {
  "data-testid"?: string;
  dimmed?: boolean;
  pill?: boolean;
};

export function Skeleton({ dimmed, pill, ...props }: SkeletonProps) {
  const sx: SxProps<Theme> | undefined =
    dimmed || pill
      ? {
          ...(dimmed ? { bgcolor: "rgba(0, 0, 0, 0.11)" } : undefined),
          ...(pill ? { borderRadius: "calc(infinity * 1px)" } : undefined),
        }
      : undefined;

  return <MuiSkeleton sx={sx} {...props} />;
}
